import { CTASection } from "./CTASection";
import { CardFeatures } from "./CardFeatures/CardFeatures";
import { CardHeroSection } from "./CardHeroSection/CardHeroSection";

export const Card = () => {
  return (
    <>
      <CardHeroSection />
      <CardFeatures />
      <CTASection />
    </>
  );
};
